<div class="col-md-12 mb-30" [hidden]="ExpertCalibrationEdit.id>0">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات پرسنلی</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">نام و نام خانوادگی</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">نوع لیست</label>
          <select class="custom-select" [(ngModel)]="Filter_person" name="SubmitPeriodDate">
            <option value="1">لیست فعال</option>
            <option value="2">همه موارد</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button type="button" (click)="ReadData_Persone()" class="btn btn-info" style="margin-left: 5px;"><i
              class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <button routerLink="/PersonAdd" type="button" class="btn btn-success" style="margin-left: 5px;"><i
              class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </button>
          <button (click)="exportexcel()" type="button" class="btn btn-warning" style="margin-left: 5px;"><i
              class="fa   fa-file-excel-o"></i> Excel </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام و نام خانوادگی</th>
              <th>کدملی</th>
              <th>تاریخ استخدام در بهینه</th>
              <th>علامت اختصاری در بهینه فرآیند آزما</th>
              <th>کارشناس کالیبراسیون</th>
              <th>وضعیت</th>
              <th>تاریخ</th>
              <th>کاربر</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Persone
            |filter:Filter_title:'fullname'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Persone|filter:Filter_title:'fullname').length
                      }
            ">
              <td>{{DataList_Persone.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <td>{{item.codemeli}}</td>
              <td>{{item.tarikh_Eshtekhdam}}</td>
              <td>{{item.almat_Ekhtesari}}</td>
              <td>
                <p *ngIf="item.expert_Calibration==0" style="color: crimson;">ثبت نشده است</p>
                <p *ngIf="item.expert_Calibration==1" style="color: #489b39;">داخل آزمایشگاه</p>
                <p *ngIf="item.expert_Calibration==2" style="color: #489b39;">خارج آزمایشگاه</p>
                <p *ngIf="item.expert_Calibration==3" style="color: #489b39;">داخل/خارج آزمایشگاه</p>
              </td>
              <td>
                <p *ngIf="!item.del" style="color: #489b39;">فعال</p>
                <p *ngIf="item.del" style="color: crimson;">غیر فعال</p>
              </td>
              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a class="dropdown-item" [routerLink]="['/PersonEdit',{id:item.id}]"><i class="fa fa-edit"></i>
                        ویرایش اطلاعات پرسنلی </a>


                      <a *ngIf="item.del==false" style="cursor: pointer;" class="dropdown-item"
                        (click)="openModal(template,item)"><i class="fa fa-lock"></i> غیرفعال </a>
                      <a *ngIf="item.del==true" style="cursor: pointer;" class="dropdown-item"
                        (click)="openModal(template,item)"><i class="fa fa-unlock"></i> فعال </a>
                    </div>
                  </div>

                  <div *ngIf="item.DeletingProccess">
                    <img src="assets/Loading.gif" style="width: 25px;" />
                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی"
      (pageChange)="page = $event"></pagination-controls>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete.del==false" class="modal-title pull-left">تایید غیرفعال اطلاعات پرسنلی
      '{{Data_Seleted_Delete.fullname}}' </h4>
    <h4 *ngIf="Data_Seleted_Delete.del==true" class="modal-title pull-left">تایید فعال اطلاعات پرسنلی
      '{{Data_Seleted_Delete.fullname}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete.del==false" type="button" class="btn btn-warning"
      (click)="Delete(Data_Seleted_Delete)"> غیرفعال اطلاعات <i class="fa fa-lock"></i></button>
    <button *ngIf="Data_Seleted_Delete.del==true" type="button" class="btn btn-warning"
      (click)="Delete(Data_Seleted_Delete)"> فعال اطلاعات <i class="fa fa-unlock"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateExpertCalibrationEdit>
  <div class="modal-header">
    <h4 class="modal-title pull-left">تایید حدف اطلاعات کارشناس کالیبراسیون '{{Data_Seleted_Delete.fullname}} ' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeleteExpertCalibration.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="DeleteExpertCalibration()"> حذف اطلاعات <i
        class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_DeleteExpertCalibration.hide()">بستن</button>
  </div>
</ng-template>

<app-ExpertCalibrationEdit *ngIf="ExpertCalibrationEdit.id>0" [innerPersonRecord]="ExpertCalibrationEdit"
  (OnBack_Expert_Calibration_Action)="OnSet_ExpertCalibrationEdit($event)">

</app-ExpertCalibrationEdit>


<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>

      <th>نام</th>
      <th>نام خانوادگی</th>
      <th>جنسیت</th>
      <th>وضیعت تأهل</th>
      <th>محل صدور</th>
      <th>شماره شناسنامه</th>
      <th>شماره سری شناسنامه</th>
      <th>کد ملّی (بدون صفر اول)</th>
      <th>شماره بیمه</th>
      <th>پدر</th>
      <th>شغل پدر</th>
      <th>شماره همراه (بدون صفر اول)</th>
      <th>مسکن</th>
      <th>ایمیل</th>
      <th>آدرس منزل فعلی</th>
      <th>کدپستی</th>
      <th>تلفن</th>
      <th>وضعیت نظام وظیفه</th>
      <th>توضیحات وضعیت نظام وظیفه</th>
      <th>از تاریخ تا تاریخ</th>
      <th>نام همسر</th>
      <th>تعداد فرزندان</th>
      <th>کد ملّی همسر (بدون صفر اول)</th>
      <th>شماره همراه همسر (بدون صفر اول)</th>
      <th>تحصیلات همسر</th>
      <th>تاریخ تولد همسر</th>
      <th>شغل همسر</th>


      <th>از سال/ماه 1</th>
      <th>تا سال/ماه 1</th>
      <th>مقطع 1</th>
      <th>رشته تحصیلی 1</th>
      <th>گرایش 1</th>
      <th>دانشگاه/موسسه آموزش عالی 1</th>
      <th>معدل 1</th>
      <th>بارگذاری مدرک تحصیلی 1</th>

      <th>از سال/ماه 2</th>
      <th>تا سال/ماه 2</th>
      <th>مقطع 2</th>
      <th>رشته تحصیلی 2</th>
      <th>گرایش 2</th>
      <th>دانشگاه/موسسه آموزش عالی 2</th>
      <th>معدل 2</th>
      <th>بارگذاری مدرک تحصیلی 2</th>

      <th>از سال/ماه 3</th>
      <th>تا سال/ماه 3</th>
      <th>مقطع 3</th>
      <th>رشته تحصیلی 3</th>
      <th>گرایش 3</th>
      <th>دانشگاه/موسسه آموزش عالی 3</th>
      <th>معدل 3</th>
      <th>بارگذاری مدرک تحصیلی 3</th>


      <th>از سال/ماه 1</th>
      <th>تا سال/ماه 1</th>
      <th>نام شرکت/سازمان 1</th>
      <th>نوع استخدام 1</th>
      <th>سمت 1</th>
      <th>علت ترک خدمت 1</th>
      <th>تلفن 1</th>
      <th>آدرس 1</th>

      <th>از سال/ماه 2</th>
      <th>تا سال/ماه 2</th>
      <th>نام شرکت/سازمان 2</th>
      <th>نوع استخدام 2</th>
      <th>سمت 2</th>
      <th>علت ترک خدمت 2</th>
      <th>تلفن 2</th>
      <th>آدرس 2</th>

      <th>از سال/ماه 3</th>
      <th>تا سال/ماه 3</th>
      <th>نام شرکت/سازمان 3</th>
      <th>نوع استخدام 3</th>
      <th>سمت 3</th>
      <th>علت ترک خدمت 3</th>
      <th>تلفن 3</th>
      <th>آدرس 3</th>

      <th>از سال/ماه 1</th>
      <th>تا سال/ماه 1</th>
      <th>سرفصل دوره آموزشی 1</th>
      <th>عنوان دوره آموزشی 1</th>
      <th>مدت(ساعت) 1</th>
      <th>برگزار کننده 1</th>
      <th>بارگذاری مدرک تحصیلی 1</th>

      <th>از سال/ماه 2</th>
      <th>تا سال/ماه 2</th>
      <th>سرفصل دوره آموزشی 2</th>
      <th>عنوان دوره آموزشی 2</th>
      <th>مدت(ساعت) 2</th>
      <th>برگزار کننده 2</th>
      <th>بارگذاری مدرک تحصیلی 2</th>

      <th>از سال/ماه 3</th>
      <th>تا سال/ماه 3</th>
      <th>سرفصل دوره آموزشی 3</th>
      <th>عنوان دوره آموزشی 3</th>
      <th>مدت(ساعت) 3</th>
      <th>برگزار کننده 3</th>
      <th>بارگذاری مدرک تحصیلی 3</th>

      <th>مهارت 1</th>
      <th>درصد 1</th>

      <th>مهارت 2</th>
      <th>درصد 2</th>

      <th>مهارت 3</th>
      <th>درصد 3</th>

      <th>عنوان 1</th>
      <th>تاریخ 1</th>
      <th>ناشر 1</th>
      <th>لینک 1</th>

      <th>عنوان 2</th>
      <th>تاریخ 2</th>
      <th>ناشر 2</th>
      <th>لینک 2</th>

      <th>عنوان 3</th>
      <th>تاریخ 3</th>
      <th>ناشر 3</th>
      <th>لینک 3</th>

      <th>گروه اسناد 1</th>
      <th>عنوان سند 1</th>
      <th>شماره ویرایش 1</th>
      <th>تأییدکننده 1</th>


      <th>گروه اسناد 2</th>
      <th>عنوان سند 2</th>
      <th>شماره ویرایش 2</th>
      <th>تأییدکننده 2</th>


      <th>گروه اسناد 3</th>
      <th>عنوان سند 3</th>
      <th>شماره ویرایش 3</th>
      <th>تأییدکننده 3</th>

    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Persone_Excel|filter:Filter_title:'fullname'">
      <td>{{DataList_Persone_Excel.indexOf(item)+1}}</td>

      <td>{{item.fname}}</td>
      <td>{{item.lname}}</td>
      <td>{{item.sex}}</td>
      <td>{{item.vaziat_Tahol}}</td>
      <td>{{item.mahal_tavalod}}</td>
      <td>{{item.shomareh_Shenasnameh}}</td>
      <td>{{item.shomareh_Shenasnameh_Seri}}</td>
      <td>{{item.codeMeli}}</td>
      <td>{{item.shomareh_bimeh}}</td>
      <td>{{item.name_Pedar}}</td>
      <td>{{item.shoghleh_Pedar}}</td>
      <td>{{item.shomareh_Hamreh}}</td>
      <td>{{item.maskan}}</td>
      <td>{{item.email}}</td>
      <td>{{item.address_Manzel}}</td>
      <td>{{item.codeposti}}</td>
      <td>{{item.tel}}</td>
      <td>{{item.vaziat_Nazam_Vazifeh}}</td>
      <td>{{item.vaziat_Nazam_Vazifeh_Dsc}}</td>
      <td>{{item.vaziat_startDate}} - {{item.vaziat_endDate}}</td>
      <td>{{item.name_Hamsar}}</td>
      <td>{{item.tedadFarzandan}}</td>
      <td>{{item.codeMeli_Hamsar}}</td>
      <td>{{item.shomareh_hamrah_Hamsar}}</td>
      <td>{{item.tahsilat_Hamsar}}</td>
      <td>{{item.tarikh_Tavalod_Hamsar}}</td>
      <td>{{item.shoghleh_Hamsar}}</td>


      <td>{{item.date_starrt1}}</td>
      <td>{{item.date_end1}}</td>
      <td>{{item.degree1}}</td>
      <td>{{item.reshteh1}}</td>
      <td>{{item.grayesh1}}</td>
      <td>{{item.uni1}}</td>
      <td>{{item.moadel1}}</td>
      <td>{{item.image1}}</td>

      <td>{{item.date_starrt2}}</td>
      <td>{{item.date_end2}}</td>
      <td>{{item.degree2}}</td>
      <td>{{item.reshteh2}}</td>
      <td>{{item.grayesh2}}</td>
      <td>{{item.uni2}}</td>
      <td>{{item.moadel2}}</td>
      <td>{{item.image2}}</td>

      <td>{{item.date_starrt3}}</td>
      <td>{{item.date_end3}}</td>
      <td>{{item.degree3}}</td>
      <td>{{item.reshteh3}}</td>
      <td>{{item.grayesh3}}</td>
      <td>{{item.uni3}}</td>
      <td>{{item.moadel3}}</td>
      <td>{{item.image3}}</td>

      <td>{{item.date_starrtKari1}}</td>
      <td>{{item.date_endKari1}}</td>
      <td>{{item.companyNameKari1}}</td>
      <td>{{item.typeKari1}}</td>
      <td>{{item.sematKari1}}</td>
      <td>{{item.leaveKari1}}</td>
      <td>{{item.telKari1}}</td>
      <td>{{item.addressKari1}}</td>

      <td>{{item.date_starrtKari2}}</td>
      <td>{{item.date_endKari2}}</td>
      <td>{{item.companyNameKari2}}</td>
      <td>{{item.typeKari2}}</td>
      <td>{{item.sematKari2}}</td>
      <td>{{item.leaveKari2}}</td>
      <td>{{item.telKari2}}</td>
      <td>{{item.addressKari2}}</td>

      <td>{{item.date_starrtKari3}}</td>
      <td>{{item.date_endKari3}}</td>
      <td>{{item.companyNameKari3}}</td>
      <td>{{item.typeKari3}}</td>
      <td>{{item.sematKari3}}</td>
      <td>{{item.leaveKari3}}</td>
      <td>{{item.telKari3}}</td>
      <td>{{item.addressKari3}}</td>

      <td>{{item.date_starrtAmoozeshi1}}</td>
      <td>{{item.date_endAmoozeshi1}}</td>
      <td>{{item.sarFaslAmozeshi_idAmoozeshi1}}</td>
      <td>{{item.dorehAmoozeshi_idAmoozeshi1}}</td>
      <td>{{item.modatAmoozeshi1}}</td>
      <td>{{item.bargozarKonnadehAmoozeshi1}}</td>
      <td>{{item.imageAmoozeshi1}}</td>

      <td>{{item.date_starrtAmoozeshi2}}</td>
      <td>{{item.date_endAmoozeshi2}}</td>
      <td>{{item.sarFaslAmozeshi_idAmoozeshi2}}</td>
      <td>{{item.dorehAmoozeshi_idAmoozeshi2}}</td>
      <td>{{item.modatAmoozeshi2}}</td>
      <td>{{item.bargozarKonnadehAmoozeshi2}}</td>
      <td>{{item.imageAmoozeshi2}}</td>

      <td>{{item.date_starrtAmoozeshi3}}</td>
      <td>{{item.date_endAmoozeshi3}}</td>
      <td>{{item.sarFaslAmozeshi_idAmoozeshi3}}</td>
      <td>{{item.dorehAmoozeshi_idAmoozeshi3}}</td>
      <td>{{item.modatAmoozeshi3}}</td>
      <td>{{item.bargozarKonnadehAmoozeshi3}}</td>
      <td>{{item.imageAmoozeshi3}}</td>

      <td>{{item.skill_id1}}</td>
      <td>{{item.percennt1}}</td>

      <td>{{item.skill_id2}}</td>
      <td>{{item.percennt2}}</td>

      <td>{{item.skill_id3}}</td>
      <td>{{item.percennt3}}</td>

      <td>{{item.title1}}</td>
      <td>{{item.tarikh1}}</td>
      <td>{{item.nasher1}}</td>
      <td>{{item.link1}}</td>

      <td>{{item.title2}}</td>
      <td>{{item.tarikh2}}</td>
      <td>{{item.nasher2}}</td>
      <td>{{item.link2}}</td>

      <td>{{item.title3}}</td>
      <td>{{item.tarikh3}}</td>
      <td>{{item.nasher3}}</td>
      <td>{{item.link3}}</td>


      <td>{{item.grpDoc_id1}}</td>
      <td>{{item.tlDoc_id1}}</td>
      <td>{{item.shomareh1}}</td>
      <td>{{item.taminKonandeh1}}</td>

      <td>{{item.grpDoc_id2}}</td>
      <td>{{item.tlDoc_id2}}</td>
      <td>{{item.shomareh2}}</td>
      <td>{{item.taminKonandeh2}}</td>

      <td>{{item.grpDoc_id3}}</td>
      <td>{{item.tlDoc_id3}}</td>
      <td>{{item.shomareh3}}</td>
      <td>{{item.taminKonandeh3}}</td>

    </tr>
  </tbody>
</table>